import pgAdapter from "common/Adapters/PGAdapter/PGAdapter";
export const fetchAllExperts = async (selectedFilters, chosenSortItem, memberType, language) => {
  const CURRENT_MAX_EXPERTS_NUMBER = 200;
  const PAGE = 0;
  const data = {
    item_per_page: CURRENT_MAX_EXPERTS_NUMBER,
    page: PAGE,
    name: selectedFilters.name,
    "gender[]": `{${selectedFilters.genders.join(",")}}`,
    "city[]": `{${selectedFilters.cities.join(",")}}`,
    "state[]": `{${selectedFilters.states.join(",")}}`,
    "country[]": `{${selectedFilters.countries.join(",")}}`,
    "member_type[]": `{${selectedFilters.member_types.join(",")}}`,
    "section[]": `{${selectedFilters.sections.join(",")}}`,
    "professional_group[]": `{${selectedFilters.professional_groups.join(",")}}`,
    "commission[]": `{${selectedFilters.sia_commissions.join(",")}}`,
    "specialist[]": `{${selectedFilters.specialists.join(",")}}`,
    "work_specialisation[]": `{${selectedFilters.work_specialisations.join(",")}}`,
    "work_branch[]": `{${selectedFilters.work_branches.join(",")}}`,
    is_specialist: true,
    has_references: selectedFilters.has_ref_objects,
    has_jobs: selectedFilters.has_jobs,
    chosen_sort: chosenSortItem.sortMapping,
    "current_selected_type[]": `{${Array.isArray(memberType) ? memberType.join(",") : memberType}}`,
  };

  let allExperts = await new Promise((resolve, reject) => {
    pgAdapter.getIndividualMembers(
      data,
      (response) => {
        let membersHashes = response.data.members.map((e) => e.hashed_member_id);
        return resolve(membersHashes);
      },
      (error) => reject(error)
    );
  });

  let membersDetails = [];

  for (const hash of allExperts) {
    let memberDetails = await new Promise((resolve, reject) => {
      pgAdapter.getMemberDetails(
        {
          lang: pgAdapter.getLocale(language),
          hashed_member_id: hash,
        },
        (response) => {
          response.data.hash = hash;
          return resolve(response.data);
        },
        (error) => reject(error)
      );
    });
    membersDetails.push(memberDetails);
  }
  return membersDetails;
};
